"use strict";
exports.__esModule = true;
exports.validateUserAgreementName = function (value) {
    value = value.trim();
    if (!value) {
        return 'Название не может быть пустым';
    }
    return '';
};
